import { all, put, takeLatest } from "redux-saga/effects";

import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import MessagingService from "../../services/utils/MessagingService";
import {
  componentKey,
  setCloseCreateGroup,
  setCloseBroadcast,
  setConversationList,
  setIsUserAdded,
  setUsersListData,
  setGroupCreate,
} from "./messagingSlice";

export const {
  getUserList,
  postConversationData,
  getConversationList,
  patchConversationData,
  clearAllNotification,
  patchVerifyOrder,
  deleteNotification,
  postGroupCreate,
  getGroupCreated,
  patchGroupMemberAndGroupName,
  postBroadcast,
} = {
  getUserList: (payload) => {
    return {
      type: "MESSAGING/USER_LIST",
      payload,
    };
  },
  postConversationData: (payload) => {
    return {
      type: "MESSAGING/POST_CONVERSION_DATA",
      payload,
    };
  },
  postBroadcast: (payload) => {
    return {
      type: "MESSAGING/POST_BROADCAST",
      payload,
    };
  },
  getConversationList: (payload) => {
    return {
      type: "MESSAGING/GET_CONVERSATION_LIST",
      payload,
    };
  },
  patchConversationData: (payload) => {
    return {
      type: "MESSAGING/PATCH_CONVERSATION_DATA",
      payload,
    };
  },

  clearAllNotification: (payload) => {
    return {
      type: "MESSAGING/CLEAR_ALL_NOTIFICATION",
      payload,
    };
  },
  patchVerifyOrder: (payload) => {
    return {
      type: "MESSAGING/PATCH_VERIFY_ORDER",
      payload,
    };
  },
  deleteNotification: (payload) => {
    return {
      type: "NOTIFICATION/DELETE_NOTIFICATION",
      payload,
    };
  },
  postGroupCreate: (payload) => {
    return {
      type: "MESSAGING/POST_CREATE_GROUP",
      payload,
    };
  },
  getGroupCreated: (payload) => {
    return {
      type: "MESSAGING/GET_CREATED_GROUP",
      payload,
    };
  },
  patchGroupMemberAndGroupName: (payload) => {
    return {
      type: "MESSAGING/PATCH_GROUP_MEMBER",
      payload,
    };
  },
};

// GET USER DATA ASYNC
function* getUserListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield MessagingService.getUserList(action?.payload);

    const { status, data } = response;
    if (status) {
      yield put(setUsersListData(data?.users));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setUsersListData([]));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET POST CONVERSATION DATA DATA ASYNC
function* postConversationDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield MessagingService.postConversationData(
      action?.payload
    );
    const { status, data } = response;
    if (status) {
      yield put(setIsUserAdded(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setIsUserAdded(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET POST CONVERSATION DATA DATA ASYNC
function* getConversationListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield MessagingService.getConversationList(
      action?.payload
    );

    const { status, data } = response;
    if (status) {
      yield put(setConversationList(data?.conversations));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setConversationList([]));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET POST CONVERSATION DATA DATA ASYNC
function* patchConversationDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield MessagingService.patchConversationData(
      action?.payload?.id,
      action?.payload?.apiPayload
    );
    const { status, data } = response;
    if (status) {
      yield put(setIsUserAdded(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setIsUserAdded(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET ALL NOTIFICATION ASYNC
function* clearAllNotificationAsync(action) {
  const { loginUserId, clearNotifications } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield MessagingService.clearAllNotification(loginUserId);

    const { status, message } = response;

    if (status) {
      eventEHRCustomToastMessage({
        title: `Notifications cleared successfully.`,
        status: "success",
      });
      clearNotifications();
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* patchOrderVerifyAsync(action) {
  try {
    yield put(showLoader());
    const response = yield MessagingService.patchVerifyOrderStatus(
      action?.payload?.orderId,
      action?.payload?.payload
    );
    if (response?.status) {
      const message = response?.data?.message;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET ALL NOTIFICATION ASYNC
function* deleteNotificationAsync(action) {
  try {
    yield put(showLoader());
    const response = yield MessagingService.deleteNotification(
      action?.payload?.id
    );

    if (response?.status) {
      const message = response?.data?.message;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      // action?.payload?.clearNotifications();
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* postCreateGroupAsync(action) {
  try {
    yield put(showLoader());
    const response = yield MessagingService.postGroupData(action?.payload);
    const { status, data } = response;
    if (status) {
      eventEHRCustomToastMessage({
        title: `${data?.message}`,
        status: "success",
      });
      yield put(setCloseCreateGroup(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseCreateGroup(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}
function* getGroupCreatedAsync(action) {
  try {
    yield put(showLoader());
    const response = yield MessagingService.getCreateGroupData(action?.payload);
    const { status, data } = response;
    if ((status, data)) {
      yield put(setGroupCreate(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setGroupCreate([]));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* patchNewGroupMemberWithGroupNameAsync(action) {
  try {
    yield put(showLoader());
    const response = yield MessagingService.patchGroupMemberWithGroupName(
      action?.payload?.groupId,
      action?.payload?.payload
    );
    const { status, message, data } = response;
    if (status) {
      eventEHRCustomToastMessage({
        title: `${data?.message}`,
        status: "success",
      });
      yield put(setCloseCreateGroup(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseCreateGroup(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// BROADCAST MESSAGE ASYNC
function* postBroadcastAsync(action) {
  try {
    yield put(showLoader());
    const response = yield MessagingService.postBroadcastMessage(
      action?.payload
    );
    const { status, data } = response;
    if (status) {
      eventEHRCustomToastMessage({
        title: `Message broadcast to ${data?.totalRecipients} recipient(s).`,
        status: "success",
      });
      yield put(setCloseBroadcast(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseBroadcast(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([takeLatest(getUserList().type, getUserListAsync)]);
  yield all([takeLatest(postBroadcast().type, postBroadcastAsync)]);
  yield all([
    takeLatest(postConversationData().type, postConversationDataAsync),
  ]);
  yield all([takeLatest(getConversationList().type, getConversationListAsync)]);
  yield all([
    takeLatest(patchConversationData().type, patchConversationDataAsync),
  ]);
  yield all([
    takeLatest(clearAllNotification().type, clearAllNotificationAsync),
  ]);
  yield all([takeLatest(patchVerifyOrder().type, patchOrderVerifyAsync)]);
  yield all([takeLatest(deleteNotification().type, deleteNotificationAsync)]);
  yield all([takeLatest(postGroupCreate().type, postCreateGroupAsync)]);
  yield all([takeLatest(getGroupCreated().type, getGroupCreatedAsync)]);
  yield all([
    takeLatest(
      patchGroupMemberAndGroupName().type,
      patchNewGroupMemberWithGroupNameAsync
    ),
  ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
